import React from "react";
import { Table } from "../../../../../../components";
import { IconButton, Box, Button } from "@material-ui/core";
import { useRequestContext, System } from "../../../../../../context";
import { CheckCircle as CheckCircleIcon } from "@material-ui/icons";

type Props = {
  application: System["application"];
  onSelect: (application: System["application"]) => void;
  style?: React.CSSProperties;
};

export const Option: React.FC<Props> = ({ application, onSelect, style }) => {
  const [requestContextState] = useRequestContext();

  return (
    <Table.Row key={application.id} style={style}>
      <Table.Cell>{application.name}</Table.Cell>
      <Table.Cell>{application.host}</Table.Cell>
      <Table.Cell align="center">
        {requestContextState.values.systems.find(
          (system) =>
            system.application.id === application.id &&
            system.application.manual === application.manual &&
            system.application.lz === application.lz
        ) ? (
          <IconButton
            size="small"
            onClick={() => {
              onSelect(application);
            }}
          >
            <Box display="flex" color="success.main">
              <CheckCircleIcon />
            </Box>
          </IconButton>
        ) : (
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              onSelect(application);
            }}
          >
            Select
          </Button>
        )}
      </Table.Cell>
    </Table.Row>
  );
};
